const angular = require('angular');
const { some, startsWith } = require('lodash');

module.exports = function ($rootScope, $state, shopperService, loginService, pageMetadataService, memoScroll, moveFocus, analyticsService, settings) {
    function promptForLogin(event, toState, toParams) {
        event.preventDefault();
        loginService.promptForLogin(loginService.LoginToContinueMessage, toState, toParams);
    }

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
        if (fromState.data && fromState.data.onAuthReturnToState) {
            $rootScope.onAuthRedirectedState = $state.get(fromState.data.onAuthReturnToState);
            $rootScope.onAuthRedirectedStateParams = {};
        } else {
            $rootScope.onAuthRedirectedState = fromState;
            $rootScope.onAuthRedirectedStateParams = fromParams;
        }

        if (toState.data && toState.data.authenticate && shopperService.IsGuest) {
            if (angular.isArray(toState.data.authenticate)) {
                $state.shouldAuthenticate(toState, toParams).then((requiresLogin) => {
                    if (requiresLogin) {
                        promptForLogin(event, toState, toParams);
                    }
                });
            } else {
                promptForLogin(event, toState, toParams);
            }
        }
    });

    $rootScope.$on('$stateChangeSuccess', () => {
        pageMetadataService.useCurrentStateMetadata();

        moveFocus('#body-container', true);
        moveFocus(() => $('#center-panel h1').filter(':first'), false);
    });

    $rootScope.$on('$locationChangeStart', (event, newUrl, oldUrl) => {
        memoScroll.rememberScrollPosition(oldUrl);
    });

    $rootScope.$on('$locationChangeSuccess', (event, newUrl, oldUrl = '') => {
        // Only restore the scroll position if the path has changed. This is to prevent
        // jarring scroll position changes when changing sort by options/product filters.
        const hasPathChanged = newUrl.split('?')[0] !== oldUrl.split('?')[0];

        if (!($state.current && $state.current.data && $state.current.data.optOutOfScrollRestore) && (hasPathChanged || ($state.current && $state.current.reloadOnSearch))) {
            memoScroll.restoreScrollPosition(newUrl);
        }
    });

    $rootScope.$on('$stateChangeSuccess', (event, state) => {
        if (state.name === 'root') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general, data: { page: 'root' } });
        }

        if (state.name === 'shop.page') {
            analyticsService.push({ type: analyticsService.mapperTypes.content.general });
        }

        if (startsWith(state.name, 'shop.authentication')) {
            analyticsService.push({
                data: { 'page.Type': 'account' },
                type: analyticsService.mapperTypes.content.general,
            });
        }

        if (state.name === 'shop.recipes') {
            analyticsService.push({
                data: { 'page.Type': 'content' },
                type: analyticsService.mapperTypes.content.general,
            });
        }

        if (state.name === 'shop.recipes.noSavedRecipes') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory,
            });
        }
        if (state.name === 'shop.recipes.recipenotfound') {
            analyticsService.push({
                data: { recipes: {} },
                type: analyticsService.mapperTypes.content.recipeCategory,
            });
        }

        // define other page type tealium push on route change for e.g. /shop/embedded/new-app
        if (state.name) {
            const pageTypeExceptions = settings.analytics.tealiumPageTypeExceptions;
            if (!some(pageTypeExceptions, ex => startsWith(state.name, ex))) {
                analyticsService.push({
                    data: { 'page.Type': 'other' },
                    type: analyticsService.mapperTypes.content.general,
                });
            }
        }
    });
};



// WEBPACK FOOTER //
// ./src/configuration/startup.js